import { render, staticRenderFns } from "./wechat_login_custom.vue?vue&type=template&id=684a6034&scoped=true&"
import script from "./wechat_login_custom.vue?vue&type=script&lang=js&"
export * from "./wechat_login_custom.vue?vue&type=script&lang=js&"
import style0 from "./wechat_login_custom.vue?vue&type=style&index=0&id=684a6034&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a6034",
  null
  
)

export default component.exports